type WithKey<T> = { [K in keyof T]: string };

// Generic function to get the object with the longest string value for the specified key
export const getMaxByLength = <T extends WithKey<T>, K extends keyof T>(arr: T[], key: K): T => {
  return arr.reduce((maxObj, currentObj) => {
    return currentObj[key].length > maxObj[key].length ? currentObj : maxObj;
  }, arr[0]);
};
